import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('reports-customers', storeModule.createStoreModule('reports-customers'))
